import { convertParamsToQueryString } from "../convertParamsToQueryString";

export async function deleteRequestWrapper<Params, Response>({
  url,
  idToken,
  params,
}: {
  url: string;
  idToken: string;
  params?: Params;
}): Promise<Response> {
  const response = await fetch(
    `${url}?${convertParamsToQueryString<Params | undefined>(params)}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  );

  if (!response.ok) {
    // const error: unknown = await response.json();

    // TODO - Add functionality to detect error type and print error.

    throw new Error(`Error encountered when making GET request to "${url}"`);
  }

  return response.json() as Response;
}
